import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";
import makerjs from "makerjs";
import {isEmpty} from "lodash";

export class Hexagon extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'hexagon', dimensions );
	}

	getSideLength(): Length {
		return this.cleanedPrimitives.side_length;
	}

	getLength(): Length {
		return this.cleanedPrimitives.side_length;
	}

	getWidth(): Length {
		const width = this.getSideLength().multiply(2).in_mm();

		return Length.from_mm( width );
	}

	getHeight(): Length {
		const height = Math.sqrt(3) * this.getSideLength().in_mm();

		return Length.from_mm( height );
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'side_length' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		let dimensionLines = [];

		if(focusedElement.includes("cutout_measurement") || forceRender) {
			dimensionLines = [
				new DimensionLine( [0, 0], [ 0, this.getHeight().in_mm() ], this.renderDimensionLabel( 'height', this.getHeight().in_cm() ), [-40, 0], ratio ),
				new DimensionLine( [0, 0], [ this.getWidth().in_mm(), 0 ], this.renderDimensionLabel( 'width', this.getWidth().in_cm() ), [0, -40], ratio ),
			];
		}

		if(focusedElement.includes("measurements-hexagon-side_length")) {

			// Offset the bottom left corner.
			const sideLengthOffset = this.getSideLength().divide(2);

			dimensionLines.push(new DimensionLine( [sideLengthOffset.in_mm(), 0], [ this.getSideLength().add(sideLengthOffset).in_mm(), 0 ], this.renderDimensionLabel( 'side_length' ), [0, 40], ratio, this.getDimensionLineType('measurements-hexagon-side_length', focusedElement, forceRender)));
		}

		return dimensionLines;
	}

	/**
	 * Creates a model instance of the shape.
	 */
	createModel(): void {
		if ( isEmpty( this.cleanedPrimitives ) ) {
			return;
		}

		super.createModel();

		makerjs.model.zero( this.model );
		makerjs.model.originate( this.model );
	}

	getDefaultDimensions(): Dimensions {
		return { side_length: 20 };
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();

		return {
			side_length: width.divide(4).in_cm(),
		};
	}
}
